import React from 'react';
import { compose } from 'redux'
import { connect } from 'react-redux';
import { Spinner } from 'react-activity';
import { CampaignAccess, AnalysisAccess, UserAccess } from '@sounditi/ft2-api';
import { Helmet } from 'react-helmet'
import { withTranslation } from 'react-i18next';
import ModalDialog from '../../components/ModalDialog';
import ModalDialogInfo from '../../components/ModalDialogInfo';
import Gender from '../../components/audience/Gender';
import AgeRange from '../../components/audience/AgeRange';
import TopLocations from '../../components/audience/TopLocations';
import WeekInteractions from '../../components/audience/WeekInteractions';
import MonthInteractions from '../../components/audience/MonthInteractions';
import Link from '../../components/Link';
import Input from '../../components/Input';
import Select from '../../components/Select';
import ContentHeader from '../../components/ContentHeader';
import TopBar from '../../components/TopBar';
import MobileTopBar from '../../components/MobileTopBar';
import T from '../../components/Translate';

import { getURLParameter, removeURLParameter } from '../../utils/global';
import { showNotification } from '../../reducers/notifications';
import { setRedirect } from '../../reducers/navigation';
import { setTestsData, setUserData } from '../../reducers/user';

import { URL_ENVIRONMENT } from '../../config/global';
import { URL_PRICING } from '../../config/urls';

const mapStateToProps = (state, ownProps) => ({
  userData: state.user.userData,
  testsData: state.user.testsData,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  setUserData: val => dispatch(setUserData(val)),
  setTestsData: val => dispatch(setTestsData(val)),
  setRedirect: val => dispatch(setRedirect(val)),
  showNotification: val => dispatch(showNotification(val)),
  dispatch
})

class Recopilator extends React.Component {
  _mount = true;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      loadingLink: false,
      currentLink: '',
      links: [],
      globalSummary: {},
      name: "",
      url: "",
      lang: "es",
      audience: "",
      dateEnds: "",
      dateStarts: "",
      dataValidate: true,
      campaignData: [],
      changesToApply: false,
      showUnpublishModal: false,
      showAddNewModal: false,
      showEditModal: false,
      showDeleteModal: false,
      modalLoading: false,
      modalDeleteLoading: false,
      newLinkName: "New link",
      editLink: {},
      editLinkName: "",
      deleteLink: {},
      showSummaryModal: false,
      typeModalSummary: '',
      showLinkModal: false,
      typeModalLink: '',
      currentModalLink: {},
      ShowTestsReachedModal: false,
    };
  }

  componentWillMount() {
    this.loadData();
    if (getURLParameter('paidAudience') !== null) {
      this.callbackFromStripe();
    }
  }

  componentDidMount() {

  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidUpdate() {

  }

  callbackFromStripe() {
    const { showNotification } = this.props;

    if (getURLParameter('paidAudience') === 'true') {
      this.refreshTestsData();
      showNotification('audiencePurchasedSuccesfully');
    } else {
      showNotification('audiencePurchasedError');
    }
    removeURLParameter("paidAudience");
  }

  async refreshTestsData() {
    const { setTestsData } = this.props;
    const campaignAccess = new CampaignAccess();
    const refreshedTestsData = await campaignAccess.getCampaigns();
    setTestsData(refreshedTestsData);
  }

  async refreshUserData() {
    const { setUserData } = this.props;
    const userAccess = new UserAccess();
    const refreshedUserData = await userAccess.getUserData();
    setUserData(refreshedUserData);
  }
  
  async loadData() {
    if (this._mount) {
      const { testsData } = this.props;


      const campaignId = getURLParameter("id");
      const campaignData = testsData.filter(test => test.campaignId === campaignId)[0];

      if (!campaignId || !campaignData)
        this.goCampaigns();

      if (campaignData){
        this.setState({
          campaignData,
          changesToApply: false
        }, () => {
          if (this._mount) {
            this.refreshTestsData();
          }
        });

        let links = [];
        try {
          const campaignAccess = new CampaignAccess();
          links = await campaignAccess.getLinks(campaignId);
        } catch {}

        let globalSummary = {};
        try {
          const analysisAccess = new AnalysisAccess();
          globalSummary = await analysisAccess.audienceGlobalSummary(campaignId);
        } catch {}

        this.setState({ loading: false, links, globalSummary });
      }
    }
  }

  validateData() {
    this.setState({ dataValidated: true, changesToApply: true });
  }

  onInputChange(val) {
    this.setState(val, () => {
      this.validateData();
    });
  }

  /*
  onInputChange(val, inputLink) {
    val.persist();

    const links = this.state.links.map(link => {
      if (inputLink.linkId === link.linkId) {
        link[val.target.name] = val.target.value;
      }

      return link;
    });

    this.setState(links, ()=>{
      this.validateData();
    });
  }
  */

  

  goCampaigns() {
    const { setRedirect } = this.props;
    const link = `/tests/`;
    setRedirect({ route: link });
  }

  goDesign() {
    const { setRedirect } = this.props;
    const campaignId = getURLParameter("id");
    const link = `/tests/design?id=${campaignId}`;
    setRedirect({ route: link });
  }

  nextStep() {
    // this.modifyCampaign(() => this.goDesign());
  }

  copyToClipboard(text) {
    const { showNotification } = this.props;

    let tempInput = document.createElement("input");
    tempInput.value = text;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);

    window.Froged("track", "onCopyLink");

    showNotification("copyClipboard");
  }

  openEditLink(editLink) {
    this.setState({ editLink, showEditModal: true, editLinkName: editLink.alias });
  }

  openNewLink() {
    this.setState({ newLinkName: "New link", showAddNewModal: true });
  }

  async onToggleActive(link) {
    try {
      this.setState({ modalLoading: true });
      this.setState({ loadingLink: true });
      this.setState({ currentLink: link.linkId });

      const updatedLink = { ...link, active: !link.active };

      const campaignAccess = new CampaignAccess();
      await campaignAccess.updateLink(updatedLink);

      await this.loadData();
    } catch(error) {
      showNotification("genericError");
    }

    this.setState({ modalLoading: false });
    this.setState({ loadingLink: false });
    this.setState({ currentLink: '' });
  }

  async saveLink() {
    const { editLink, editLinkName } = this.state;

    try {
      this.setState({ modalLoading: true });

      const updatedLink = { ...editLink, alias: editLinkName };

      const campaignAccess = new CampaignAccess();
      await campaignAccess.updateLink(updatedLink);

      await this.loadData();
    } catch(error) {
      showNotification("genericError");
    }

    this.setState({ modalLoading: false, showEditModal: false });
  }

  async createLink() {
    const { newLinkName, campaignData } = this.state;
    const { showNotification } = this.props;

    try {
      this.setState({ modalLoading: true });

      const newLink = {
        active: true,
        alias: newLinkName,
        campaignId: campaignData.campaignId,
        isLink: true
      };

      const campaignAccess = new CampaignAccess();
      await campaignAccess.createLink(newLink);

      await this.loadData();
      this.refreshUserData();
    } catch(error) {
      if (error.message === 'The maximum number of tests has been reached') {
        this.setState({ ShowTestsReachedModal: true });
      } else {
        showNotification("genericError");
      }
    }

    this.setState({ modalLoading: false, showAddNewModal: false, newLinkName: "" });
  }

  async deleteLink() {
    const { showNotification } = this.props;
    const { deleteLink } = this.state;

    try {
      this.setState({ modalDeleteLoading: true });

      const campaignAccess = new CampaignAccess();
      await campaignAccess.deleteLink(deleteLink);

      await this.loadData();
      this.refreshUserData();

      showNotification("linkDeletedSuccessfully");
    } catch(error) {
      showNotification("genericError");
    }
    this.setState({ modalDeleteLoading: false, showDeleteModal: false });
  }

  showModalLink(type, link) {
    this.setState({ showLinkModal: true });
    this.setState({ typeModalLink: type });
    this.setState({ currentModalLink: link });
  }

  closeModalLink() {
    this.setState({ showLinkModal: false });
    this.setState({ typeModalLink: '' });
    this.setState({ currentModalLink: {} });
  }

  showModalSummary(type) {
    this.setState({ showSummaryModal: true });
    this.setState({ typeModalSummary: type });
  }

  closeModalSummary() {
    this.setState({ showSummaryModal: false });
    this.setState({ typeModalSummary: '' });
  }

  goPricing() {
    const { setRedirect } = this.props;
    setRedirect({ route: URL_PRICING });
  }

  render() {
    const {
      loading,
      loadingLink,
      currentLink,
      campaignData,
      changesToApply,
      links,
      globalSummary,
      showAddNewModal,
      showEditModal,
      showDeleteModal,
      modalLoading,
      modalDeleteLoading,
      newLinkName,
      editLinkName,
      deleteLink,
      showSummaryModal,
      typeModalSummary,
      showLinkModal,
      typeModalLink,
      currentModalLink,
      ShowTestsReachedModal,
    } = this.state;
    const { location, t, userData } = this.props;

    const campaignName = campaignData.data ? campaignData.data.name : "";

    const checkData = (object, value) => {
      if (object
        && object.end_details
        && object.end_details[value]
        && object.end_details[value] !== '') {
          return object.end_details[value];
        } else {
          return value === 'number_of_testers' ? '0' : '-';
        }
    }

    const checkLocation = (object) => {
      let location = '-';
      let locationCity = '';
      let locationCountry = '';

      if (object && object.end_details ) {
        if (
          object.end_details.predominant_location_city
          && object.end_details.predominant_location_city !== ''
        ) {
          locationCity = object.end_details.predominant_location_city;
        }

        if (
          object.end_details.predominant_location_country
          && object.end_details.predominant_location_country !== ''
        ) {
          locationCountry = object.end_details.predominant_location_country;
          locationCountry = locationCity !== '' ? `(${locationCountry})` : locationCountry;
        }

        if (locationCity !== '' || locationCountry !== '') {
          location = `${locationCity} ${locationCountry}`.trim();
        }
      }
      return location;
    }

    const locationSummary = checkLocation(globalSummary.global_summary);
    const renderSummary =
      <>
        <ModalDialogInfo
          name="Gender"
          showModal={showSummaryModal && typeModalSummary == 'gender'}
          closeModal={() => this.closeModalSummary()}
        >
          <Gender
            ref="gender"
            activeModule={true}
          />
        </ModalDialogInfo>
        <ModalDialogInfo
          name="AgeRange"
          showModal={showSummaryModal && typeModalSummary == 'ages'}
          closeModal={() => this.closeModalSummary()}
        >
          <AgeRange
            ref="ageRange"
            activeModule={true}
          />
        </ModalDialogInfo>
        <ModalDialogInfo
            name="TopLocations"
            showModal={showSummaryModal && typeModalSummary == 'locations'}
            closeModal={() => this.closeModalSummary()}
          >
          <TopLocations
            ref="topLocations"
            activeModule={true}
          />
        </ModalDialogInfo>
        <ModalDialogInfo
          name="Responses"
          showModal={showSummaryModal && typeModalSummary == 'responses'}
          closeModal={() => this.closeModalSummary()}
          largeModal={true}
        >
          <div className="responses-obtained-modal">
            <div className="responses-chart">
              <WeekInteractions
              ref="weekInteractions"
              activeModule={true}
            />
            </div>
            <div className="responses-chart">
              <MonthInteractions
              ref="monthInteractions"
              activeModule={true}
            />
            </div>
          </div>
        </ModalDialogInfo>
      <div className="content-widget summary">
        <div className="summary">
          <div className="col featured" onClick={() => this.showModalSummary('responses')}>
              <div className="summary-icon"><img src="../assets/img/icon-responses.png" alt="Responses obtained" /></div>
              <div className="title"><T text="Recopilator_Metrics_Responses" /></div>
              <div className="value">{checkData(globalSummary.global_summary, 'number_of_testers')}</div>
          </div>
          <div className="col" onClick={() => this.showModalSummary('locations')}>
            <div className="summary-icon"><img src="../assets/img/icon-location.png" alt="Top location" /></div>
            <div className="title"><T text="Recopilator_Metrics_Location" /></div>
            <div className={`value ${locationSummary !== '-' ? "top-location" : ""}`}>{locationSummary}</div>
          </div>
          <div className="col" onClick={() => this.showModalSummary('gender')}>
            <div className="summary-icon"><img className="top-gender" src="../assets/img/icon-gender.png" alt="Top gender" /></div>
            <div className="title"><T text="Recopilator_Metrics_Genre" /></div>
            <div className="value">{checkData(globalSummary.global_summary, 'predominant_gender')}</div>
          </div>
          <div className="col" onClick={() => this.showModalSummary('ages')}>
            <div className="summary-icon"><img src="../assets/img/icon-age.png" alt="Average age" /></div>
            <div className="title"><T text="Recopilator_Metrics_Age" /></div>
            <div className="value">{checkData(globalSummary.global_summary, 'predominant_age_track')}</div>
          </div>
        </div>
      </div>
      </>;


    const renderLinks = links.filter(link => link.isLink === true).map(link => {
      const url = `${URL_ENVIRONMENT}/${link.linkUrl}`;
      const locationLinks = checkLocation(link.linkStatistics);

      return (
        <div className="content-widget link" key={link.linkId}>
          {loadingLink && (currentLink === link.linkId) && (
            <div className="loading-cover">
              <div className="cover"></div>
              <div>
                <Spinner speed={0.8} color="#00C7E7" size={20} />
              </div>
            </div>
          )}
          <div className="alias">
            <div className="alias-text">
              <div className="alias-name" onClick={() => this.openEditLink(link)}>
                <span onClick={() => this.openEditLink(link)} ref="alias">{link.alias}</span>
                <i className="icon icon-pencil-1"></i>
              </div>
              <div className="alias-buttons" onClick={() => this.setState({ showDeleteModal: true, deleteLink: link })}>
                <i className="icon icon-trash-1"></i>
              </div>
            </div>
            <div className="active">
              <div className="label"><T text="Recopilator_Links_Toggle" /></div>
                <div className={link.active ? 'button-toggle active' : 'button-toggle'} onClick={() => this.onToggleActive(link)}>
                <div className="handle"></div>
              </div>
            </div>
          </div>
          <div className="link">
            <i className="icon icon-link-1"></i>
            <input
              placeholder="..."
              readOnly
              name="linkUrl"
              value={url}
              ref="linkUrl"
              onChange={val => () => {}}
            />
            <Link
              main
              onClick={() => this.copyToClipboard(url)}
            >
              <T text="Recopilator_Links_Copy" />
            </Link>
          </div>
          <div className="metrics">
            <div className="col featured">
              <div className="title"><T text="Recopilator_Metrics_Responses" /></div>
              <div className="value">{checkData(link.linkStatistics, 'number_of_testers')}</div>
            </div>
            <div className="col" onClick={() => this.showModalLink('locations', link)}>
              <div className="title"><T text="Recopilator_Metrics_Location" /></div>
              <div className={`value ${locationLinks !== '-' ? "top-location" : ""}`}>{locationLinks}</div>
            </div>
            <div className="col" onClick={() => this.showModalLink('gender', link)}>
              <div className="title"><T text="Recopilator_Metrics_Genre" /></div>
            <div className="value">{checkData(link.linkStatistics, 'predominant_gender')}</div>
            </div>
            <div className="col" onClick={() => this.showModalLink('ages', link)}>
              <div className="title"><T text="Recopilator_Metrics_Age" /></div>
            <div className="value">{checkData(link.linkStatistics, 'predominant_age_track')}</div>
            </div>
          </div>
        </div>
      );
    });

    const renderLinksPaid = links.filter(link => link.isLink === false).map(link => {

      // Change [0] if in the future there are multiple segments in a link.
      const totalPaidResponses = link.paidAudienceSegments[0].numberOfPeople;
      const genre = link.paidAudienceSegments[0].genre;
      const country = link.paidAudienceSegments[0].country;
      const country_truncated = country.length > 30 ? country.slice(0,30).trim().concat('...') : country;
      const fromAge = link.paidAudienceSegments[0].fromAge;
      const toAge = link.paidAudienceSegments[0].toAge;

      let age = `${fromAge} - ${toAge}`;
      if (fromAge === toAge) {
        age = fromAge;
      }

      return (
        <div className="content-widget link link-paid" key={link.linkId}>
          {loadingLink && (currentLink === link.linkId) && (
            <div className="loading-cover">
              <div className="cover"></div>
              <div>
                <Spinner speed={0.8} color="#FB8500" size={20} />
              </div>
            </div>
          )}
          <div className="alias">
            <h2 className="total-responses">{`(${totalPaidResponses})`}</h2>
            <input
              placeholder="..."
              readOnly
              name="alias"
              value={link.alias}
              ref="alias"
              onChange={val => () => {}}
              onClick={() => this.openEditLink(link)}
            />
            {/*
            <Link secondary onClick={() => { this.openEditLink(link) }}>
              <T text="Recopilator_Links_Paid_Button" />
            </Link>
            */}
          </div>
          <div className="metrics">
            <div className="col featured">
              <div className="title"><T text="Recopilator_Metrics_Responses" /></div>
              <div className="value">{checkData(link.linkStatistics, 'number_of_testers')}</div>
            </div>
            <div className="col">
              <div className="title"><T text="Recopilator_Links_Paid_Location" /></div>
              <div className={`value ${country !== 'All' ? "top-location" : ""}`}>{country_truncated}</div>
            </div>
            <div className="col">
              <div className="title"><T text="Recopilator_Links_Paid_Genre" /></div>
              <div className="value">{genre}</div>
            </div>
            <div className="col">
              <div className="title"><T text="Recopilator_Links_Paid_Age" /></div>
              <div className="value">{age}</div>
            </div>
          </div>
        </div>
      );
    });

    return (
      <div className="app screen-campaigns">
        <Helmet>
          <title>{t('Configuration_Browser_Title')}</title>
        </Helmet>
        <ModalDialog
          name="Recopilator_Add_Link"
          showModal={showAddNewModal}
          loading={modalLoading}
          closeModal={e => { this.setState({ showAddNewModal: false }) }}
          onConfirm={() => { this.createLink() }}
        >
          <Input
            readOnly={modalLoading}
            placeholder=""
            name="newLinkName"
            label={t('Recopilator_Add_Link_Input_Name')}
            value={newLinkName}
            ref="newLinkName"
            onChange={val => this.onInputChange(val)}
          />
        </ModalDialog>
        <ModalDialog
          name="Recopilator_Edit_Link"
          showModal={showEditModal}
          loading={modalLoading}
          closeModal={e => { this.setState({ showEditModal: false }) }}
          onConfirm={() => { this.saveLink() }}
        >
          <Input
            readOnly={modalLoading}
            placeholder=""
            name="editLinkName"
            label={t('Recopilator_Edit_Link_Input_Name')}
            value={editLinkName}
            ref="editLinkName"
            onChange={val => this.onInputChange(val)}
          />
        </ModalDialog>
        <ModalDialog
          name="Recopilator_Delete_Link"
          showModal={showDeleteModal}
          loading={modalDeleteLoading}
          closeModal={e => { this.setState({ showDeleteModal: false }) }}
          onCancel={e => { this.setState({ showDeleteModal: false }) }}
          onConfirm={() => { this.deleteLink() }}
        >
          {deleteLink.linkStatistics?.end_details?.number_of_testers > 0
            ?
              <div className="delete-link-modal">
                <p className="warning-text"><T text="Recopilator_Delete_Link_Modal_Text_1" /></p>
                <p className="icon-text"><i className="icon icon-error"></i><T text="Recopilator_Delete_Link_Modal_Text_2" /></p>
                <p className="icon-text"><i className="icon icon-error"></i><T text="Recopilator_Delete_Link_Modal_Text_3" /></p>
                <p className="last-text"><T text="Recopilator_Delete_Link_Modal_Text_4" var1={deleteLink.alias} /></p>
              </div>
            :
              <div className="delete-link-modal">
                <p className="warning-text"><T text="Recopilator_Delete_Link_Modal_Text_4" var1={deleteLink.alias} /></p>
                <p className="icon-text"><i className="icon icon-error"></i><T text="Recopilator_Delete_Link_Modal_Text_3" /></p>
              </div>
          }
        </ModalDialog>
        <ModalDialog
          name="Recopilator_User_Max_Tests_Reached"
          showModal={ShowTestsReachedModal}
          smallSize={true}
          closeModal={() => this.setState({ ShowTestsReachedModal: false }) }
          //onCancel={() => this.setState({ ShowTestsReachedModal: false }) }
          //onConfirm={() => {this.goPricing(); this.setState({ ShowTestsReachedModal: false }) }}
          onConfirm={() => this.setState({ ShowTestsReachedModal: false }) }
        >
          <p>
            <T
              text="Recopilator_User_Max_Tests_Reached_Modal_Text_1"
              var1={userData.subscription.name}
              var2={userData.subscription.total_test}
            />
          </p>
          <p><T text="Recopilator_User_Max_Tests_Reached_Modal_Text_2" /></p>
        </ModalDialog>
        <div className="main-wrapper">
          <TopBar ref="topbar" location={location} />
          <MobileTopBar
            subtitle={campaignName}
            title={t('ContentHeader_Get_Responses')}
            onClickBackButton={() => window.history.back()}
          />
          <div className="screen-content">
            <ContentHeader
              location={location}
              campaignData={campaignData}
              changesToApply={changesToApply}
            />
            <div className="content-wrapper recopilator small">
              {loading && (
                <div className="loading-cover">
                  {/* <div className="cover design"></div> */}
                  <div>
                    <Spinner speed={0.8} color="#00C7E7" size={20} />
                  </div>
                </div>
              )}

              {!loading && (
                <>
                  <h2><T text="Recopilator_GlobalSummary_Title" /></h2>
                  {renderSummary}
                  <h2><T text="Recopilator_Links_Title" /></h2>
                  <p><T text="Recopilator_Links_Text" /></p>
                  <ModalDialogInfo
                    name="Gender"
                    nameElement={currentModalLink.alias}
                    showModal={showLinkModal && typeModalLink == 'gender'}
                    closeModal={() => this.closeModalLink()}
                  >
                    <Gender
                      ref="gender"
                      currentModalLink={currentModalLink}
                    />
                  </ModalDialogInfo>
                  <ModalDialogInfo
                    name="AgeRange"
                    nameElement={currentModalLink.alias}
                    showModal={showLinkModal && typeModalLink == 'ages'}
                    closeModal={() => this.closeModalLink()}
                  >
                    <AgeRange
                      ref="ageRange"
                      currentModalLink={currentModalLink}
                    />
                  </ModalDialogInfo>
                  <ModalDialogInfo
                    name="TopLocations"
                    nameElement={currentModalLink.alias}
                    showModal={showLinkModal && typeModalLink == 'locations'}
                    closeModal={() => this.closeModalLink()}
                  >
                    <TopLocations
                      ref="topLocations"
                      currentModalLink={currentModalLink}
                    />
                  </ModalDialogInfo>
                  {renderLinks}
                  <div className="content-widget link add-new" onClick={() => this.openNewLink()}>
                    <div className="add-new-label">
                      <div className="icon-wrapper">
                        <i className="icon icon-plus-1"></i>
                      </div>
                      <div className="label"><T text="Recopilator_Links_Add" /></div>
                    </div>
                    <div className="alias">
                      <input value="New link" onChange={e => {}} />
                      <div className="active">
                        <div className="label"><T text="Recopilator_Links_Toggle" /></div>
                          <div className="button-toggle active">
                          <div className="handle"></div>
                        </div>
                      </div>
                    </div>
                    <div className="link">
                      <i className="icon icon-link-1"></i>
                      <input value="https:// ..." onChange={e => {}} />
                      <Link main><T text="Recopilator_Links_Copy" /></Link>
                    </div>
                    <div className="metrics">
                      <div className="col featured">
                      </div>
                      <div className="col">
                      </div>
                      <div className="col">
                      </div>
                      <div className="col">
                      </div>
                    </div>
                  </div>
                  <h2><T text="Recopilator_Links_Paid_Title" /></h2>
                  <p><T text="Recopilator_Links_Paid_Text" /></p>
                  {renderLinksPaid}
                  <div className="content-widget link link-paid add-new" onClick={() => this.refs.topbar.goBuyAudience(campaignData)}>
                    <div className="add-new-label">
                      <div className="icon-wrapper">
                        <i className="icon icon-plus-1"></i>
                      </div>
                      <div className="label"><T text="Recopilator_Links_Paid_Add" /></div>
                    </div>
                    <div className="alias">
                      <input value="New link" onChange={e => {}} />
                      {/*
                      <Link secondary>
                        <T text="Recopilator_Links_Paid_Button" />
                      </Link>
                      */}
                    </div>
                    <div className="metrics">
                      <div className="col featured">
                      </div>
                      <div className="col">
                      </div>
                      <div className="col">
                      </div>
                      <div className="col">
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(Recopilator);
